export function updateRangeSelection(
  orderedIds: string[],
  selectedIds: Set<string>,
  anchorId: string | null,
  targetId: string,
  selected: boolean,
) {
  const next = new Set(selectedIds)
  const anchorIndex = anchorId == null ? -1 : orderedIds.indexOf(anchorId)
  const targetIndex = orderedIds.indexOf(targetId)
  const ids = anchorIndex < 0 || targetIndex < 0
    ? [targetId]
    : orderedIds.slice(Math.min(anchorIndex, targetIndex), Math.max(anchorIndex, targetIndex) + 1)

  ids.forEach(id => selected ? next.add(id) : next.delete(id))
  return next
}
